var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentCheckSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-check-search 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 20.75C6.7595 20.75 5.75 19.7405 5.75 18.5V5.5C5.75 4.2595 6.7595 3.25 8 3.25H14.2525L18.25 7.2185V18.5C18.25 19.7405 17.2405 20.75 16 20.75H8Z",
    fill: "#DCDDE0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1495 3.5L18 7.3225V18.5C18 19.603 17.103 20.5 16 20.5H8C6.897 20.5 6 19.603 6 18.5V5.5C6 4.397 6.897 3.5 8 3.5H14.1495ZM14.3555 3H8C6.6195 3 5.5 4.1195 5.5 5.5V18.5C5.5 19.8805 6.6195 21 8 21H16C17.3805 21 18.5 19.8805 18.5 18.5V7.1145L14.3555 3Z",
    fill: "#CBCCCF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8585 7.1145H18.5L14.3555 3V5.6225C14.3555 6.4465 15.0285 7.1145 15.8585 7.1145Z",
    fill: "#AEAFB6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 17H11.5C11.224 17 11 16.7765 11 16.5C11 16.2235 11.224 16 11.5 16H16C16.2765 16 16.5 16.2235 16.5 16.5C16.5 16.7765 16.2765 17 16 17Z",
    fill: "#AEAFB6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16 14H11.5C11.224 14 11 13.7765 11 13.5C11 13.2235 11.224 13 11.5 13H16C16.2765 13 16.5 13.2235 16.5 13.5C16.5 13.7765 16.2765 14 16 14Z",
    fill: "#AEAFB6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16 11H11.5C11.224 11 11 10.7765 11 10.5C11 10.2235 11.224 10 11.5 10H16C16.2765 10 16.5 10.2235 16.5 10.5C16.5 10.7765 16.2765 11 16 11Z",
    fill: "#AEAFB6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.59601 11.4945C8.43101 11.4945 8.27651 11.43 8.16001 11.313L7.62001 10.7735C7.42451 10.5785 7.42451 10.262 7.62001 10.0665C7.81501 9.871 8.13151 9.871 8.32701 10.0665L8.59551 10.335L9.27901 9.652C9.47451 9.4565 9.79051 9.4565 9.98601 9.652C10.1815 9.8475 10.1815 10.1635 9.98601 10.359L9.03051 11.3145C8.91601 11.43 8.76101 11.4945 8.59601 11.4945ZM8.32401 10.607L8.32301 10.608L8.32401 10.607ZM8.86651 10.6055L8.86801 10.607L8.86651 10.6055Z",
    fill: "#505363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.59601 14.4945C8.43151 14.4945 8.27751 14.4305 8.16101 14.3145L7.62001 13.774C7.42451 13.5785 7.42451 13.2625 7.62001 13.067C7.81501 12.8715 8.13151 12.8715 8.32701 13.067L8.59551 13.3355L9.27901 12.652C9.47451 12.4565 9.79051 12.4565 9.98601 12.652C10.1815 12.8475 10.1815 13.1635 9.98601 13.359L9.03051 14.3145C8.91501 14.4305 8.76051 14.4945 8.59601 14.4945Z",
    fill: "#505363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.59601 17.4945C8.43151 17.4945 8.27751 17.4305 8.16101 17.3145L7.62001 16.774C7.42451 16.5785 7.42451 16.2625 7.62001 16.067C7.81501 15.8715 8.13151 15.8715 8.32701 16.067L8.59551 16.3355L9.27901 15.652C9.47451 15.4565 9.79051 15.4565 9.98601 15.652C10.1815 15.8475 10.1815 16.1635 9.98601 16.359L9.03051 17.3145C8.91501 17.4305 8.76051 17.4945 8.59601 17.4945Z",
    fill: "#505363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.7891 20.906C15.6306 20.906 15.4716 20.8455 15.3511 20.7245L11.9556 17.33C11.7131 17.0875 11.7131 16.696 11.9556 16.4535C12.1981 16.211 12.5896 16.211 12.8321 16.4535L16.2276 19.848C16.4701 20.0905 16.4701 20.482 16.2276 20.7245C16.1056 20.845 15.9471 20.906 15.7891 20.906Z",
    fill: "#898B94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M8.9585 17.7945C11.3546 17.7945 13.297 15.8521 13.297 13.456C13.297 11.0599 11.3546 9.11749 8.9585 9.11749C6.56241 9.11749 4.62 11.0599 4.62 13.456C4.62 15.8521 6.56241 17.7945 8.9585 17.7945Z",
    fill: "#445EFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.9095 21.092L16.595 22.4065C16.474 22.5275 16.2775 22.5275 16.157 22.4065L12.502 18.7515C12.381 18.6305 12.381 18.434 12.502 18.3135L13.8165 16.999C13.9375 16.878 14.134 16.878 14.2545 16.999L17.9095 20.654C18.03 20.7745 18.03 20.971 17.9095 21.092Z",
    fill: "#445EFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M8.9585 18.4115C7.6885 18.4115 6.419 17.9285 5.452 16.9615C4.5155 16.026 4 14.781 4 13.456C4 12.131 4.5155 10.886 5.452 9.94951C7.386 8.01651 10.5315 8.01651 12.4645 9.94951C14.3975 11.8825 14.3975 15.0285 12.4645 16.9615C11.4985 17.929 10.2285 18.4115 8.9585 18.4115ZM8.9585 9.73901C8.0065 9.73901 7.054 10.1015 6.3285 10.826C5.626 11.5285 5.2395 12.4625 5.2395 13.456C5.2395 14.4495 5.6265 15.383 6.3285 16.0855C7.7785 17.5345 10.138 17.5335 11.5885 16.0855C13.0385 14.6355 13.0385 12.276 11.5885 10.8265C10.8635 10.101 9.9105 9.73901 8.9585 9.73901Z",
    fill: "#898B94"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCheckSearch);
export default __webpack_public_path__ + "static/media/document-check-search.b2760cea07c76ac9c4944160bc04ce44.svg";
export { ForwardRef as ReactComponent };